import { render, staticRenderFns } from "./AdobePremiereIcon.vue?vue&type=template&id=3267ab34&scoped=true"
import script from "./AdobePremiereIcon.vue?vue&type=script&lang=js"
export * from "./AdobePremiereIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3267ab34",
  null
  
)

export default component.exports